"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Toggle;

var _react = _interopRequireWildcard(require("react"));

var _useClassBuilder = _interopRequireDefault(require("../../hooks/useClassBuilder"));

var _useStyleBuilder = _interopRequireDefault(require("../../hooks/useStyleBuilder"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*---------------------------------------------*/
var BASE_CLASS = "lth-c-toggle";
/*---------------------------------------------*/

function Toggle(props) {
  var ref = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(props.value),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  if (typeof props.value !== "undefined" && props.value !== "") {
    // if a valid value was passed through props - use that one
    if (value !== props.value) {
      setValue(props.value);
    }
  }

  var customClasses = [];
  props.size && customClasses.push("".concat(BASE_CLASS, "--").concat(props.size));
  props.direction && customClasses.push("".concat(BASE_CLASS, "--").concat(props.direction));
  value && customClasses.push("lth-is-checked");
  var message = null;

  if (props.message) {
    message = /*#__PURE__*/_react.default.createElement("div", {
      className: BASE_CLASS + "__message"
    }, props.message);
  }

  var label = typeof props.label === "undefined" ? "Label" : props.label;
  var labelSize = props.size === "small" ? "small" : "regular";
  var classes = (0, _useClassBuilder.default)(props, BASE_CLASS, customClasses);
  var style = (0, _useStyleBuilder.default)(props);
  var divProps = {
    className: classes,
    style: style,
    tabIndex: props.disabled ? undefined : 0,
    onKeyDown: onKeyDown
  };
  return /*#__PURE__*/_react.default.createElement("div", divProps, /*#__PURE__*/_react.default.createElement("label", {
    className: BASE_CLASS + "__container",
    onClick: onToggle,
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: BASE_CLASS + "__label"
  }, /*#__PURE__*/_react.default.createElement(_.Text, {
    size: labelSize
  }, label), message), /*#__PURE__*/_react.default.createElement("div", {
    className: BASE_CLASS + "__track"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: BASE_CLASS + "__handle"
  }))));
  /*------------------------------------------*/

  function onToggle(e) {
    if (props.disabled) {
      return;
    }

    var newValue = !value;
    setValue(newValue);
    props.onChange && props.onChange(newValue, props.name);
  }

  function onKeyDown(e) {
    // allow using space to toggle the checkbox value
    if (e.keyCode === 32) {
      e.preventDefault();
      ref.current.click();
    }
  }
}
/*----*/


Toggle.METADATA = {
  name: "Toggle",
  props: [{
    name: "label",
    type: "string",
    description: "Input label"
  }, {
    name: "value",
    type: "string",
    description: "Current value",
    options: [{
      value: undefined,
      label: "Not set"
    }, {
      value: true,
      label: "True"
    }, {
      value: false,
      label: "False"
    }]
  }, {
    name: "size",
    type: "string",
    options: [{
      value: "medium"
    }, {
      value: "small"
    }]
  }, {
    name: "direction",
    type: "string",
    description: "The direction of the toggle label relative to the handle",
    options: [{
      value: "left"
    }, {
      value: "right"
    }, {
      value: "top"
    }],
    category: "style"
  }, {
    name: "disabled",
    type: "boolean",
    description: "Set disabled state"
  }, {
    name: "forcefocus",
    type: "boolean",
    default: false,
    description: "Force focus state."
  }, {
    name: "message",
    type: "string",
    description: "Message displayed in the component"
  }, {
    name: "onChange",
    type: "function",
    description: "Callback function called after the value is changed"
  }]
};